import type { Paginated } from '@partou/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AppContextService, DEFAULT_LIMIT } from '@partou/core';
import { map, type Observable } from 'rxjs';
import type { ApiLocationsResponse, Location, LocationsQuery } from '../types';
import { toLocation } from '../mappers/locations.api';

const LOCATIONS_ENDPOINT: Readonly<string> = '/locations';
const SORT_FIELD: Readonly<string> = 'name';
const SORT_DIRECTION: Readonly<string> = 'ASC';

@Injectable()
export class LocationsApiService {
  private readonly http: HttpClient = inject(HttpClient);
  private readonly context: AppContextService = inject(AppContextService);

  getLocations(query: LocationsQuery = {}): Observable<Paginated<Location>> {
    let params: HttpParams = new HttpParams()
      .set('limit', query.limit ?? DEFAULT_LIMIT)
      .set('offset', query.offset ?? 0)
      .set('sortField', SORT_FIELD)
      .set('sortDirection', SORT_DIRECTION);
    if (query.nameSearch !== undefined && query.nameSearch !== '') {
      params = params.set('nameSearch', query.nameSearch);
    }
    return this.http.get<ApiLocationsResponse>(this.context.buildEndpoint(LOCATIONS_ENDPOINT), { params }).pipe(
      map(
        (response: ApiLocationsResponse): Paginated<Location> => ({
          items: response.items.map(toLocation),
          total: response.pagination?.total,
        }),
      ),
    );
  }
}
